import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = {
  class: "scroll-y mh-450px",
  style: {"min-height":"150px"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fad fa-people-group fa-4x" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder fs-3 text-white text-hover-white" }, "Add Group", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "d-flex flex-column"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "d-flex align-items-center flex-grow-1 me-2 me-sm-5" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-50px me-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "symbol-label bg-secondary" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-people-group fa-2x text-white" })
  ])
], -1)
const _hoisted_10 = { class: "me-2" }
const _hoisted_11 = { class: "text-white fs-4 fw-bolder" }
const _hoisted_12 = { class: "fw-bolder d-block fs-7" }
const _hoisted_13 = { class: "d-flex align-items-center d-none" }
const _hoisted_14 = { class: "d-block d-md-none col" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-plus text-primary mb-5 fs-2x" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "text-white fs-5 fw-bold mb-2" }, "Add Group", -1)
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_Button = _resolveComponent("Button")!
  const _component_GroupModal = _resolveComponent("GroupModal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      (_ctx.groupsFiltered.length === 0)
        ? (_openBlock(), _createBlock(_component_el_empty, {
            key: 0,
            description: "create custom groups like cast, crew, production team, ensemble to make it easier to schedule calls and send out communications"
          }, {
            image: _withCtx(() => [
              _hoisted_3
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "btn btn-sm btn-primary d-flex flex-column flex-center",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.invokeAddGroup && _ctx.invokeAddGroup(...args)))
              }, _hoisted_5)
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupsFiltered, (group) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "d-flex border border-gray-300 border-dashed rounded p-6 mb-6 cursor-pointer",
                onClick: ($event: any) => (_ctx.invokeManageGroup(group)),
                key: group.groupId
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, _toDisplayString(group.name), 1),
                    _createElementVNode("span", _hoisted_12, _toDisplayString(group.description), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_Button, {
                    type: "",
                    class: "btn-outline-primary btn-outline text-white btn-sm",
                    onClick: ($event: any) => (_ctx.invokeManageGroup(group))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Manage Members ")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ])
              ], 8, _hoisted_7))
            }), 128)),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", {
                class: "d-flex card flex-center bg-light-primary border-primary border border-dashed p-8 mb-6",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.invokeAddGroup && _ctx.invokeAddGroup(...args)))
              }, _hoisted_17)
            ])
          ]))
    ])), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode(_component_GroupModal, {
      ref: "groupModal",
      people: _ctx.people
    }, null, 8, ["people"])
  ]))
}